import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { Link, NavLink } from "react-router-dom";

// reactstrap components
import { Row, Col } from "reactstrap";

import * as actions from "../../store/actions/index";

//onGetEvents

const Event = (props) => {
  const { onGetEvents } = props;

  useEffect(() => {
    onGetEvents();
  }, []);

  return (
    <Col className="ml-auto mr-auto" md="10">
      <Row className="collections">
        {props.event.map((item) => (
          <Col md="6">
            {/* ${item.data.name} */}
            <NavLink
              key={item.id}
              to={`/Method`}
              tag={Link}
              onClick={() => {
                props.onGetUserEvents(props.user.userId, item.id);
                props.onSelectEvent({ eventId: item.id, data: item.data });
              }}
            >
              <img
                //   onClick={() => }
                style={{ cursor: "pointer" }}
                alt="..."
                className="img-raised"
                src={item.data.imageSource}
              ></img>
            </NavLink>
          </Col>
        ))}
      </Row>
    </Col>
  );
};

const mapStateToProps = (state) => {
  return {
    athlete: state.strava.athlete,
    profileImage: state.strava.profileImage,
    firstName: state.strava.firstName,
    lastName: state.strava.lastName,
    city: state.strava.city,
    activities: state.strava.activities,
    authenticated: state.authentication.authenticated,
    event: state.event.events,
    selectedEvent: state.event.selectedEvent,
    user: state.authentication.user,
    eventEntered: state.event.eventEntered,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetEvents: () => dispatch(actions.getEvents()),
    onSelectEvent: (event) => dispatch(actions.selectEvent(event)),
    onGetUserEvents: (userId, eventId) =>
      dispatch(actions.getUserEvents(userId, eventId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Event);
